import {Component, OnInit} from '@angular/core';
import {ApiClientService} from '../../../services/api-client.service';
import {DirectoryService} from '../../../services/directory.service';
import {SettingsSmsService} from '../../../services/settings-sms.service';
import {AccountPermissionsService} from '../../../services/account-permissions.service';

declare const toastr: any;

@Component({
    selector: 'settings-sms-detailed-view',
    templateUrl: './settings-sms-detailed-view.component.html',
    styleUrls: ['./settings-sms-detailed-view.component.scss']
})

export class SettingsSmsDetailedViewComponent implements OnInit {
    disabledFileInput = false;
    noEdit = false;
    isFromEditMode = false;

    constructor(public api: ApiClientService,
                public accountService: AccountPermissionsService,
                public settingsSmsService: SettingsSmsService,
                public directoryService: DirectoryService) {
    }

    ngOnInit() {
        this.settingsSmsService.onDetailedViewToggle.subscribe(res => this.isFromEditMode = false);
    }

    changeEnableStatus(value): void {
        this.noEdit = true;
        const url = `/v1/cn_settings/${this.settingsSmsService.selectedItemData.id}/${value ? 'enable' : 'disable'}`;
        this.settingsSmsService.api.post('domainSms', url, {}).subscribe(
            () => this.updateView('The Field was updated successfully', false),
            (error) => {
                if(JSON.parse(error._body).errors && JSON.parse(error._body).errors.length > 0)
                    JSON.parse(error._body).errors.forEach(error => toastr.error(error.description));
                else
                    toastr.error('Update failed!');
            },
            () => { this.noEdit = false; }
        );
    }

    installSmsNotifications() {
        const data = {friendlyName: this.settingsSmsService.selectedItemData.corporationNumberName};
        const url = `/v1/cn_settings/${this.settingsSmsService.selectedItemData.id}/install`;
        this.settingsSmsService.api.post('domainSms', url, data).subscribe(
            () => this.updateView('Service has been installed successfully', false),
            (error) => {
                if(JSON.parse(error._body).errors && JSON.parse(error._body).errors.length > 0)
                    JSON.parse(error._body).errors.forEach(error => toastr.error(error.description));
                else
                    toastr.error('Update failed!');
            },
            () => { this.noEdit = false; }
        );
    }

    uninstallSmsNotifications() {
        const url = `/v1/cn_settings/${this.settingsSmsService.selectedItemData.id}/uninstall`;
        this.settingsSmsService.api.post('domainSms', url, {}).subscribe(
            () => this.updateView('Service has been uninstalled successfully', false),
            (error) => {
                if(JSON.parse(error._body).errors && JSON.parse(error._body).errors.length > 0)
                    JSON.parse(error._body).errors.forEach(error => toastr.error(error.description));
                else
                    toastr.error('Update failed!');
            },
            () => { this.noEdit = false; }
        );
    }

    updateView(msg: string, close = true): void {
        if (msg) toastr.success(msg);
        if (close)
            this.settingsSmsService.toggleDetailedView(null, false);
        else {
            const data = {
                id: this.settingsSmsService.selectedItemData.corporationNumberId,
                name: this.settingsSmsService.selectedItemData.corporationNumberName
            };
            this.settingsSmsService.toggleDetailedView(data, true);
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-sms/settings-sms-detailed-view/settings-sms-detailed-view.component.ts